import Vue from 'vue';
import { FormModel, Skeleton } from 'ant-design-vue';
import "ant-design-vue/es/form-model/style/index.css";
import "ant-design-vue/es/skeleton/style/index.css";

Vue.use(FormModel)
Vue.use(Skeleton)
